import { render, staticRenderFns } from "./index.vue?vue&type=template&id=481dbbc2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style1 from "./index.vue?vue&type=style&index=1&id=481dbbc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481dbbc2",
  null
  
)

export default component.exports